import { useMemo, useState } from 'react'
import { formatInTimeZone } from 'date-fns-tz'
import clsx from 'clsx'

import { useGetVehicleAssignmentsHistory } from '../api/useGetVehicleAssignmentsHistory'
import { RoutesFilter } from './RoutesFilter'
import { Loader } from '@/ui/Loader'
import { RunHistory } from '@/types/vehicleAllocation'
import { sortVehicleAssignmentsHistory } from '../helpers/sortVehicleAssignmentsHistory'

import styles from './VehicleAllocationList.module.scss'

export const VehicleAllocationList = () => {
    const [selectedRoutes, setSelectedRoutes] = useState<string[]>([])

    const { data: historyData, isLoading } = useGetVehicleAssignmentsHistory()

    const formattedDate = useMemo(() => {
        if (!historyData) {
            return []
        }

        const sortedHistory = sortVehicleAssignmentsHistory(historyData.assignments)

        if (!selectedRoutes.length) {
            return sortedHistory
        }

        return sortedHistory.filter((item) => selectedRoutes.includes(item.route))
    }, [selectedRoutes, historyData])

    const availableRoutes = useMemo(() => {
        if (!historyData) {
            return []
        }

        return sortVehicleAssignmentsHistory(historyData.assignments).map((item) => item.route)
    }, [historyData])

    const formatDisplayedTime = ({ time, changedAt, changed }: RunHistory) => {
        return changed && changedAt ? formatInTimeZone(changedAt, 'UTC', 'HH:mm') : time.replace('.', ':')
    }

    if (isLoading) {
        return <Loader />
    }

    return (
        <div className={styles.root}>
            <RoutesFilter
                selectedValues={selectedRoutes}
                availableRoutes={availableRoutes}
                onChange={setSelectedRoutes}
            />
            <div className={styles.scrollContainer}>
                {formattedDate.map((item) => (
                    <div key={item.route} className={styles.container}>
                        <p className={styles.routeName}>{item.route}</p>
                        <div className={styles.list}>
                            {item.runs.map(({ run, history }) => (
                                <div key={run} className={styles.allocationItem}>
                                    <p className={styles.runNumber}>{run ?? '-'}</p>
                                    <div className={styles.items}>
                                        {!history.length && <span className={styles.text}>No vehicles allocated</span>}
                                        {!!history.length &&
                                            history.map((item) => (
                                                <div key={item.bonnet} className={styles.itemWrapper}>
                                                    <div className={styles.infoWrapper}>
                                                        <p className={styles.text}>{formatDisplayedTime(item)}</p>
                                                        <p className={styles.text}>
                                                            {item.changed ? 'edited' : 'run out'}
                                                        </p>
                                                        <p className={clsx(styles.text, styles.bonnet)}>
                                                            {item.bonnet ?? '-'}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
